import { atom } from 'jotai';

// Talkdown state atoms
export const isTalkdownActiveAtom = atom<boolean>(false);

export const isConnectedAtom = atom<boolean>(false);

// Combined talkdown state atom (for convenience)
export const talkdownStateAtom = atom(
  (get) => ({
    isTalkdownActive: get(isTalkdownActiveAtom),
    isConnected: get(isConnectedAtom),
  }),
  (_get, set, newState: { isTalkdownActive?: boolean; isConnected?: boolean }) => {
    if (newState.isTalkdownActive !== undefined) {
      set(isTalkdownActiveAtom, newState.isTalkdownActive);
    }
    if (newState.isConnected !== undefined) {
      set(isConnectedAtom, newState.isConnected);
    }
  }
);
